import { useContext } from 'react';
import { VideoUploadContext } from '../context/VideoUploadContext';
import { VideoUploadContextValue } from '../context/video-upload.types';

export function useVideoUploads(): VideoUploadContextValue {
  const context = useContext(VideoUploadContext);

  if (!context) {
    throw new Error('useVideoUploads must be used inside VideoUploadProvider');
  }

  return context;
}
